<template>
	<div class="grid pb-0" id="d-stop-sell">
		<div class="border-top-unset">
			<v-progress-linear
				color="warning"
				indeterminate
				rounded
				height="3"
				v-if="isLoading || isLoadingUpdate"
			></v-progress-linear>
			<div v-if="!isLoading" class="d-stop-sell-mobile">
                <v-toolbar
                dense
                class="toolbar-update-range"
                >
                <v-btn
                    icon
                    light
                    @click="closeUpdateRange()"
                >
                    <v-icon color="grey darken-2">
                    arrow_back_ios
                    </v-icon>
                </v-btn>

                <v-toolbar-title class="grey--text text--darken-4 fs-15" >
                    <strong>{{$t('UPDATE_TO_STOP_SELLING_OPENING')}}</strong>
                </v-toolbar-title>
                </v-toolbar>
                <div class="h-100 content-update-range-stopsell">
                    <label class="pr-0 fs-10"> {{ $t("ROOM_CLASS") }} </label>
					<v-chip-group
						v-model="selectedRoomTypeUpdate"
						:column="true"
						multiple
						pill
						active-class="primary--text"
					>
						<v-chip filter v-for="(i, index) in listRoomUpdate"  :value="i.value" class="w-100 mb-1 mr-0">
							{{i.text}}
						</v-chip>
					</v-chip-group>
                    <!-- <v-autocomplete item-text="text" item-value="value" :items="listRoomUpdate" v-model="selectedRoomTypeUpdate" outlined chips dense multiple deletable-chips>
						<template slot="no-data">
                            <div class="no-data">{{ $t("NO_DATA") }}</div>
                        </template>
                    </v-autocomplete> -->
                    <label class="pr-0 fs-10 mt-3"> {{ $t("ROOMPLAN") }} </label>
					<v-chip-group
						v-model="selectedRatePlanUpdate"
						:column="true"
						multiple
						pill
						active-class="primary--text"
					>
						<v-chip filter v-for="(i, index) in listRatePlan"  :value="i.value" class="w-100 mb-1 mr-0">
							{{i.text}}
						</v-chip>
					</v-chip-group>
                    <!-- <v-autocomplete item-text="text" item-value="value" :items="listRatePlan" v-model="selectedRatePlanUpdate" outlined chips dense multiple deletable-chips>
						<template slot="no-data">
                            <div class="no-data">{{ $t("NO_DATA") }}</div>
                        </template>
                    </v-autocomplete> -->
                    <label class="pr-0 fs-10 mt-3"> {{ $t("SALE_CHANNEL") }} </label>
					<v-chip-group
						v-model="selectedOtaUpdate"
						:column="true"
						multiple
						pill
						active-class="primary--text"
					>
						<v-chip filter v-for="(i, index) in listOtaUpdate"  :value="i.value" class="w-100 mb-1 mr-0">
							{{i.text}}
						</v-chip>
					</v-chip-group>
                    <!-- <v-autocomplete item-text="text" item-value="value" :items="listOtaUpdate" v-model="selectedOtaUpdate" outlined chips dense multiple deletable-chips>
						<template slot="no-data">
                            <div class="no-data">{{ $t("NO_DATA") }}</div>
                        </template>
                    </v-autocomplete> -->
                    <label class="pr-0 fs-10 mt-3"> {{ $t("TIME_APPLICATION") }} </label>
                    <date-picker :disabled-date="notBeforeToday" :confirm="true" :confirm-text="$t('CONFIRM')" :clearable="false"  :editable="false"
                        :popup-class="'popup-calendar-mobile'" v-model="dateSelect" :lang="languageDate" :format="'DD/MM/YYYY'" 
                        :shortcuts=[] range placeholder="Select date range">
                    </date-picker>

					 <!-- <v-btn-toggle v-model="valueUpdate" borderless dense class="mt-4" background-color="primary">
						<v-btn :value="true">
							<span>{{$t('STOP_SELL')}}</span>
						</v-btn>

						<v-btn :value="false">
							<span>{{$t('UN_STOP_SELL')}}</span>
						</v-btn>
					</v-btn-toggle> -->
					<v-radio-group v-model="valueUpdate" row >
						<v-radio color="primary"
							:label="$t('STOP_SELL')"
							value="STOP"
						></v-radio>
						<v-radio color="primary"
							:label="$t('UN_STOP_SELL')"
							value="REMOVE"
						></v-radio>
					</v-radio-group>

                    <div class="d-btn-update justify-content-between">
                       <v-btn color="primary" @click="confirmUpdateRestriction(valueUpdate === 'STOP' ? true : false)" :disabled="selectedRoomTypeUpdate.length === 0 || selectedRatePlanUpdate.length === 0 || selectedOtaUpdate.length === 0">
                            {{$t('UPDATE')}}
                        </v-btn>
                        <!-- <v-btn color="primary" @click="confirmUpdateRestriction(valueUpdate)" :disabled="selectedRoomTypeUpdate.length === 0 && selectedRatePlanUpdate.length === 0 || selectedOtaUpdate.length === 0">
                            {{$t('UN_STOP_SELL')}}
                        </v-btn> -->
                   </div>
                </div>
            </div>
		</div>
		<v-alert
			dismissible
			type="success"
		 	class="alert-custom-stopsell"
			 v-model="alert"
    		>
    		<span class="fs-10">{{$t(content)}}</span>
		</v-alert>
	</div>
</template>

<script>
import { sale_room } from "@/_services/SaleRoom/sale-room.js";
import moment from "moment";
import { _alert } from "@/_helpers/function.js";
import { restriction } from "@/_services/SaleRoom/restriction.js";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
export default {
	components: {
		 "date-picker": DatePicker,
	},
	data() {
		return {
			isLoading: true,
			systemLang: this.$i18n.locale,
			listRoomUpdate: [],
			selectedRoomTypeUpdate: [],
			hasRoomRate: [],
			listRatePlan: [],
			selectedOtaUpdate: [],
			listOtaUpdate: [],
			selectedRatePlanUpdate: [],
			dateSelect: [],
			currentRestriction: null,
			isLoadingUpdate: false,
			alert: false,
			content: 'STOPSELL_UPDATE_SUCCESS',
			valueUpdate: 'STOP',
		};
	},
	watch: {
		selectedRoomTypeUpdate(val) {
			const listRatePlans = [];
			this.hasRoomRate.forEach(r => {
				if (val.includes(r.id)) {
					r.ratePlans.forEach(p => {
						listRatePlans.push({
							value: p.id,
							text: p.i18ns.find((y) => y.lang == this.defaultI18n).name,
						})
					})
				}
			})
			this.listRatePlan =  Array.from(new Set(listRatePlans.map(JSON.stringify))).map(JSON.parse);
			this.selectedRatePlanUpdate = [];
		},
		selectedRatePlanUpdate(val) {
			const listOtas = [];
			this.hasRoomRate.forEach(r => {
				if (this.selectedRoomTypeUpdate.includes(r.id)) {
					r.ratePlans.forEach(p => {
						if (this.selectedRatePlanUpdate.includes(p.id)) {
							p.roomRates.forEach(o => {
								listOtas.push({
									value: o.ota.id,
									text: o.ota.otaI18n.find((y) => y.lang == this.defaultI18n).name,
								});
							});
						}
					});
				}
			});
			this.listOtaUpdate =  Array.from(new Set(listOtas.map(JSON.stringify))).map(JSON.parse);
			this.selectedOtaUpdate = [];
		},
	 },
	mounted() {
		this.initialize();
	},
	methods: { 
		initialize() {
			this.getAllRoomDefault();
			this.getAllRestriction();
			const fromDateListOfPeriod = moment(new Date()).format("YYYY-MM-DD");
			const toDateListOfPeriod = moment(new Date())
				.add(1, "day")
				.format("YYYY-MM-DD");

			this.dateSelect = [new Date(fromDateListOfPeriod), new Date(toDateListOfPeriod)];
		},
		getAllRestriction() {
			let body = {};
			body.keyword = "";
			body.status = 1;
			body.limit = 100;
			body.offset = 0;
			body.orderBy = "active";
			body.asc = true;

			restriction.getAllPackageRestriction(body).then((res) => {
				if (res.responseCode == 0) {
					if (res.data.length > 0) {
						this.currentRestriction = res.data[0].id;
					}
				}
			});
		},
		async getAllRoomDefault() {
			await restriction.getAllRoomTyeHasRoomRate().then((res) => {
				if (res.responseCode == 0) {
					this.hasRoomRate = res.data;
					this.listRoomUpdate = [];
					this.listRoomUpdate = this.listRoomUpdate.concat(
						res.data.map((room) => {
							return {
								value: room.id,
								text: room.roomTypeI18n.find((x) => x.lang === this.defaultI18n).name,
							};
						})
					);
				}
                this.isLoading = false;
			});
		},
        closeUpdateRange() {
            window.history.back();
        },
		confirmUpdateRestriction(val) {
			if (this.get_day_of_time(new Date(this.dateSelect[0]), new Date(this.dateSelect[1])) > 365) {
				_alert(null, this.$t("UPDATE_INTERVAL_IS_NOT_MORE_THAN_ONE_YEAR"));
				return true
			}
			if (!this.currentRestriction) {
				_alert(null, this.$t("ERROR"));
				return
			}
			this.isLoadingUpdate = true;
			const data = [];
			let arrPlan = [];
				let arr = JSON.parse(JSON.stringify(this.hasRoomRate.filter(e => this.selectedRoomTypeUpdate.includes(e.id))));
				arr.forEach((x) => {
					if(x.ratePlans.filter(p => this.selectedRatePlanUpdate.includes(p.id)).length > 0) {
						x.ratePlans.filter(p => this.selectedRatePlanUpdate.includes(p.id)).forEach(plan => {
							arrPlan.push({
								roomTypeId: x.id,
								ratePlanId: plan.id,
								fromTo: [{
									dateStart: moment(this.dateSelect[0]).format("YYYY-MM-DD"),
									dateEnd: moment(this.dateSelect[1]).format("YYYY-MM-DD"),
									restrictions:  [
										{
											dayOfWeek: 1,
											value: val,
										},
										{
											dayOfWeek: 2,
											value: val,
										},
										{
											dayOfWeek: 3,
											value: val,
										},
										{
											dayOfWeek: 4,
											value: val,
										},
										{
											dayOfWeek: 5,
											value: val,
										},
										{
											dayOfWeek: 6,
											value: val,
										},
										{
											dayOfWeek: 7,
											value: val,
										}
									],
								}],
							})
						})
					}
				});
				if (this.selectedOtaUpdate.length > 0) {
					this.selectedOtaUpdate.forEach((y) => {
						arrPlan.forEach(pl => {
							data.push({
								otaId: y,
								roomTypeId: pl.roomTypeId,
								ratePlanId: pl.ratePlanId,
								restrictionPlanId: this.currentRestriction,
								fromTo: pl.fromTo,
								updateField: 'closed',
							});
						})
					});
				}
			
			if (this.selectedRoomTypeUpdate.length > 0 && this.selectedRatePlanUpdate.length > 0 && this.selectedOtaUpdate.length > 0) {
				restriction
				.batchUpdate(data)
				.then((res) => {
					if (res.responseCode === 0) {
						this.alert = true;
						this.content = val === true ? 'STOPSELL_UPDATE_SUCCESS' : 'REMOVE_STOPSELL_SUCCESS';
						setTimeout(() => {
							this.alert = false;
						}, 5000);
					} else {
						_alert(res, this.$t(res.data), false);
					}
					
				})
				.finally(
					() => (
						(this.isLoadingUpdate = false)
					)
				);
			} else {
				this.isLoadingUpdate = false;
				_alert("null", this.$t("CHANNEL_EMPTY"));
			}
		},
		remove (item, arr) {
			const index = arr.indexOf(item.value)
			if (index >= 0) arr.splice(index, 1)
		},
		_moment: moment
	}
};
</script>
